/**
 * Shared catalog accents for Games and Decision Moments.
 * Blue means ready to open, teal means completed, slate means not available yet.
 */

export const PRACTICE_LIST = {
  ready: {
    accent: '#1565c0',
    soft: '#e8f2fb',
  },
  completed: {
    accent: '#0f766e',
    soft: '#ecfdf8',
  },
  unavailable: {
    accent: '#475569',
    soft: '#f8fafc',
  },
};
